import React from "react";
import PropTypes from "prop-types";
import DropdownFilter from "../../../../components/DropdownFilter";

import { remapedUiClassificationLabel } from "../../../../utils";
import {
  extractedFilesToolbarFilterItemStyles,
  extractedFilesToolbarButtonStyles
} from "./ExtractedFilesTableToolbarStyles";

const extractedFilesClassificationItems = (valuesObject, withAll = false) => {
  const menuItems = [];
  if (withAll) {
    menuItems.push({
      label: (
        <span>
          <span className="threat threat-placeholder" /> Classification
        </span>
      ),
      value: ""
    });
  }
  menuItems.push(
    ...Object.entries(valuesObject)
      .map(([k, v]) => ({
        label: (
          <span>
            <span className={`threat threat--${k.toLowerCase()}`} />{" "}
            {remapedUiClassificationLabel(k)}
          </span>
        ),
        value: v
      }))
      .reverse()
  );
  return menuItems;
};

const ExtractedFilesClassificationFilter = ({
  index,
  disabled,
  onChange,
  filter,
  filterValues,
  withAllFilter = false
}) => {
  const menuItems = extractedFilesClassificationItems(
    filterValues,
    withAllFilter
  );
  const titleValue = menuItems.find(item => item.value === filter)?.label;

  return (
    <DropdownFilter
      eventKey={index}
      field="extracted-files-type-filter"
      title={<span>{titleValue}</span>}
      styles={extractedFilesToolbarButtonStyles}
      activeFilter={filter}
      menuItems={menuItems}
      menuItemStyles={extractedFilesToolbarFilterItemStyles}
      onFilterChange={selectedFilter => {
        onChange({ value: selectedFilter.value });
      }}
      disabled={disabled}
      styleVariant="primary"
    />
  );
};

export default ExtractedFilesClassificationFilter;

ExtractedFilesClassificationFilter.propTypes = {
  index: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  filterValues: PropTypes.objectOf(PropTypes.number).isRequired,
  withAllFilter: PropTypes.bool
};
